/* Variant of the table for large screens, where everything is expanded horizontally */
import { Stack, Text, Grid, Group, Flex } from "@mantine/core";
import { IconCurrencyEthereum } from "@tabler/icons";
import EthAddress from "../EthAddress/EthAddress";

export default function DelegatorTableFlipped(props) {
  return (
    <Stack spacing={24} sx={{ width: "100%" }}>
      <Text size="xl" fw={700}>
        Pool Delegators
      </Text>
      {props.sortedDelegators.map(function (thisTrancoder, idx) {
        return (
          <Stack spacing={24} key={"transcoder-" + idx}>
            <Grid
              columns={12}
              sx={{
                borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
                borderTop: "1px solid rgba(107, 110, 112, 0.25)",
                borderRadius: "7px",
              }}
            >
              <Grid.Col span={3}>
                <Text>Address</Text>
              </Grid.Col>
              <Grid.Col span={9}>
                <EthAddress
                  address={thisTrancoder.ID}
                  cachedENS={props.cachedENS}
                />
              </Grid.Col>
            </Grid>
            <Grid columns={12}>
              <Grid.Col span={6}>
                <Text>Stake</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                {thisTrancoder.bondedAmount.toFixed(2)} LPT
              </Grid.Col>
            </Grid>
            <Grid columns={12}>
              <Grid.Col span={6}>
                <Text>Share</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  {(
                    (thisTrancoder.bondedAmount / props.totalStake) *
                    100
                  ).toFixed(2)}{" "}
                  %
                </Text>
              </Grid.Col>
            </Grid>
            <Grid columns={12}>
              <Grid.Col span={6}>
                <Text>Fees</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Group>
                  <Text>
                    {parseFloat(
                      thisTrancoder.fees + thisTrancoder.withdrawnFees
                    ).toFixed(4)}
                  </Text>
                  <IconCurrencyEthereum size={18} color={"#86c232"} />
                </Group>
              </Grid.Col>
            </Grid>
            <Grid columns={12} sx={{ marginBottom: "12px" }}>
              <Grid.Col span={6}>
                <Text>Rewards</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text>
                  {(
                    thisTrancoder.bondedAmount +
                    thisTrancoder.unbonded -
                    Math.abs(thisTrancoder.principal)
                  ).toFixed(2)}{" "}
                  LPT
                </Text>
              </Grid.Col>
            </Grid>
          </Stack>
        );
      })}
    </Stack>
  );
}
